import { useState } from "react";
import { IndianRupee, Scale, Package } from "lucide-react";
import { KycForm, KycBadge } from "@/components/KycForm";

const PERIODS = [["today", "Today"], ["week", "7 days"], ["month", "30 days"]];

export const PartnerEarnings = ({ earnings }) => {
  const [p, setP] = useState("today");
  const e = earnings[p];
  const cats = Object.entries(e.categories || {});
  const max = Math.max(1, ...cats.map(([, v]) => v));
  return (
    <div className="space-y-3 rounded-3xl bg-[#0D3B2B] p-5 text-white" data-testid="partner-earnings">
      <div className="flex items-center justify-between">
        <p className="font-bold">My ledger</p>
        <div className="flex gap-1 rounded-full bg-white/10 p-1">
          {PERIODS.map(([k, l]) => (
            <button key={k} onClick={() => setP(k)} data-testid={`partner-earnings-${k}`}
              className={`rounded-full px-3 py-1 text-xs font-bold transition-colors ${p === k ? "bg-white text-[#0D3B2B]" : "text-white/80"}`}>{l}</button>
          ))}
        </div>
      </div>
      <div className="grid grid-cols-3 gap-2">
        {[[IndianRupee, "Payout", `₹${e.payout ?? e.paid}`, "payout"], [Scale, "Collected", `${e.kg} kg`, "kg"], [Package, "Categories", cats.length, "cats"]].map(([Icon, l, v, k]) => (
          <div key={k} className="rounded-2xl bg-white/10 p-3">
            <Icon className="h-4 w-4 text-[#9BE3BF]" />
            <p className="mt-1 font-display text-xl font-extrabold" data-testid={`partner-earnings-value-${k}`}>{v}</p>
            <p className="text-[11px] text-white/70">{l}</p>
          </div>
        ))}
      </div>
      <p className="text-xs text-white/70" data-testid="partner-earnings-summary">{e.pickups} pickups · ₹{e.paid} paid · ₹{e.pending} pending</p>
      {cats.length > 0 && (
        <div className="space-y-1.5" data-testid="partner-categories">
          {cats.map(([m, kg]) => (
            <div key={m} className="text-xs">
              <div className="flex justify-between"><span>{m}</span><span className="font-bold">{kg} kg</span></div>
              <div className="mt-0.5 h-1.5 overflow-hidden rounded-full bg-white/10"><div className="h-full rounded-full bg-[#2E9E6B]" style={{ width: `${(kg / max) * 100}%` }} /></div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export const PartnerKyc = ({ kyc, docs, token, onDone }) => {
  const [open, setOpen] = useState(kyc.status !== "Approved" && kyc.status !== "Pending");
  return (
    <div className="space-y-3 rounded-3xl border border-[#D2E0D8] bg-white p-5" data-testid="partner-kyc">
      <button onClick={() => setOpen(!open)} className="flex w-full items-center justify-between" data-testid="partner-kyc-toggle">
        <span className="font-bold text-[#0D3B2B]">My KYC documents</span><KycBadge status={kyc.status} testid="partner-kyc-badge" />
      </button>
      {open && <KycForm kyc={kyc} docs={docs} uploadUrl={`/partner/${token}/kyc/upload`} submitUrl={`/partner/${token}/kyc`} onDone={onDone} />}
    </div>
  );
};
